import { AbstractCookie } from "../../cookie/AbstractCookie";
import { CookieHelper } from "../../cookie/CookieHelper";

// import SharedObject = createjs.SharedObject; // TODO: @HTML5 handle cookies

export class ABTestData extends AbstractCookie {
    //////////////////////////////////////////////
    //  defining status constants
    /////////////////////////////////////////////
    public static STATUS_ALL_OK: number = 0;
    public static STATUS_TIMEOUT_ERROR: number = 1;
    public static STATUS_NOT_READY_ERROR: number = 2;

		//////////////////////////////////////////////
		//  defining JSON variabless
		/////////////////////////////////////////////
		/*internal*/ static TEST_ID: string = "t";
		/*internal*/ static CASE_ID: string = "c";
		/*internal*/ static CLIENT_ID: string = "ci";
		/*internal*/ static CONTENT: string = "content";
		/*internal*/ static ERROR_MSG: string = "errorMsg ";
		/*internal*/ static IS_VALID: string = "v";
		/*internal*/ static PLAYER_ID: string = "p";
		/*internal*/ static INSTANCE_ID: string = "i";
		/*internal*/ static NETWORK_ID: string = "n";
		/*internal*/ static GAME_ID: string = "g";
		/*internal*/ static REFERRER: string = "referrer";
		/*internal*/ static ACCOUNT_ID: string = "accountId";
		/*internal*/ static ERROR_CODE: string = "errorCode";

    //////////////////////////////////////////////
    //  defining test data values
    /////////////////////////////////////////////

    /** sharedObject for saving test-data. */
    // TODO: @HTML5 handle cookies
    // public get cookie(): SharedObject {
    public get cookie(): any {
        // TODO: @HTML5 there is no more shared object that holds all data from a cookie
        // return this._sharedObject;
        return {};
    }

		/*internal*/ _testID: number = 0;

    /** unique id of this test */
    public get testID(): number {
        return this._testID;
    }

		/*internal*/ _caseID: number = 0;

    /** case id of this test */
    public get caseID(): number {
        return this._caseID;
    }

		/*internal*/ _clientID: string = "";

    /** unique client hash for this test */
    public get clientID(): string {
        return this._clientID;
    }

		/*internal*/ gameID: number = 0;
		/*internal*/ instanceID: number = 0;
		/*internal*/ networkID: number = 0;
		/*internal*/ playerID: number = -1;
		/*internal*/ referrer: string = "";
		/*internal*/ content: string = "";
		/*internal*/ accountID: string = "";
		/*internal*/ errorMessage: string = "";
		/** flag if this test is valid */
		/*internal*/ isValid: boolean = false;
		/*internal*/ errorCode: number = ABTestData.STATUS_ALL_OK;

    /**
     * Constructor
     */
    constructor() {
        super("ab");
        // TODO: @HTML5 handle cookies
        // this._sharedObject = SharedObject.getLocal("ABTest_" + this._testID + "_" + this.gameID, "/");

        // TODO: @HTML5 check if cookie is empty on a different way
        // if (CookieHelper.isCookieEmpty(this.sharedObject)) {
        if (CookieHelper.isCookieEmpty({})) {
            this.save();
        } else {
            this._testID = this.getAttributeAsUint(ABTestData.TEST_ID);
            this._caseID = this.getAttributeAsUint(ABTestData.CASE_ID);
            this.gameID = this.getAttributeAsUint(ABTestData.GAME_ID);
            this.instanceID = this.getAttributeAsUint(ABTestData.INSTANCE_ID);
            this.networkID = this.getAttributeAsUint(ABTestData.NETWORK_ID);
            this.playerID = this.getAttributeAsUint(ABTestData.PLAYER_ID);
            this.referrer = this.getAttributeAsString(ABTestData.REFERRER);
            this.accountID = this.getAttributeAsString(ABTestData.ACCOUNT_ID);
            this._clientID = this.getAttributeAsString(ABTestData.CLIENT_ID);
        }

    }

    /**
     * save cookie data to hard-disc
     *
     */
    public save(): void {
        this.setAttribute(ABTestData.TEST_ID, this._testID);
        this.setAttribute(ABTestData.CASE_ID, this._caseID);
        this.setAttribute(ABTestData.CLIENT_ID, this._clientID);
        this.setAttribute(ABTestData.GAME_ID, this.gameID);
        this.setAttribute(ABTestData.INSTANCE_ID, this.instanceID);
        this.setAttribute(ABTestData.NETWORK_ID, this.networkID);
        this.setAttribute(ABTestData.PLAYER_ID, this.playerID);
        this.setAttribute(ABTestData.REFERRER, this.referrer);
        this.setAttribute(ABTestData.ACCOUNT_ID, this.accountID);
    }
}

